import SearchTile from 'components/common/tiles/SearchTile';

const TILE_WIDTH = 365;
const TILE_HEIGHT = 326;
const TILE_HIGHLIGHT_WIDTH = 365;
const TILE_HIGHLIGHT_HEIGHT = 209;

export default class SearchResultTile extends SearchTile {
  static override get width() {
    return TILE_WIDTH;
  }

  static override get height() {
    return TILE_HEIGHT;
  }

  static override get highlightWidth() {
    return TILE_HIGHLIGHT_WIDTH;
  }

  static override get highlightHeight() {
    return TILE_HIGHLIGHT_HEIGHT;
  }
}
